// import React, { useState, useEffect, useMemo } from 'react';
import React, { useState, useEffect } from 'react';
import { useIntl } from 'umi';
import classNames from 'classnames';
import { Select } from 'tea-component';
import Image from '@/pages/home/components/GameImage';
import EllipsisHover from '@/pages/home/components/EllipsisHover';
import { fetchParentAndSubsidiaryCompanies } from '@/pages/intelligence/services/companies';
import './index.scss';

// group分组的group key常量
const GROUPS = {
  PARENT: 'parent',
  SUBSIDIARY: 'subsidiary',
};

interface Props {
  isDisabledOpen?: boolean; // 是否禁止打开（外面在loading时不让用户切换）
  getIsOnSubsidiary?: (val: boolean) => void;
  value: string; // 当前选中项，对应公司id
  onChange: (val: any) => void;
  className?: string;
  [keyName: string]: any; // 其他参数
}

// props的默认值
index.defaultProps = {
  isDisabledOpen: false,
  getIsOnSubsidiary: null,
  value: '',
  onChange: null,
};

/**
 * company子母公司切换组件
 */
function index(props: Props) {
  const { className, isDisabledOpen, getIsOnSubsidiary, value, onChange } = props;

  const { formatMessage } = useIntl();

  const groups = {
    [GROUPS.PARENT]: formatMessage({ id: 'dbi_company_parent' }),
    [GROUPS.SUBSIDIARY]: formatMessage({ id: 'dbi_company_subsidiary' }),
  };

  const [options, setOptions] = useState<any>([]);
  // 当前companyId是否是子公司，控制公司icon显示等
  const [isSubsidiary, setIsSubsidiary] = useState<boolean>(false);
  // 是否展示当前组件
  const [isShow, setIsShow] = useState<boolean>(false);
  // 控制组件打开/关闭
  const [open, setOpen] = useState<boolean>(false);

  // 搜索值变化/搜索触发的搜索词
  // const [searchWord, setSearchWord] = useState<string>('');
  // 自定义筛选后的选项渲染触发的搜索词
  // const [renderSearchWord, setRenderSearchWord] = useState<string>('');
  const [isEmpty, setIsEmpty] = useState(false);

  /**
   * 搜索空态判断
   * 两个搜索词不同时判断为空态
   */
  // const isSearchEmpty = useMemo(() => searchWord !== renderSearchWord, [renderSearchWord, searchWord]);

  /**
   * 获取子母公司信息
   * @param payload 当前公司id
   */
  async function getCompanyList(payload: string) {
    const res = await fetchParentAndSubsidiaryCompanies({ company_id: payload });
    const parentCompany = res?.parent_company ?? {};
    const subsidiaryCompanies = res?.subsidiary_company ?? [];

    // 判断是否是子公司
    const isSubsidiaryTmp = payload !== parentCompany?.company_id;
    // 当前公司没有子公司时不显示当前组件
    const isNoShowTmp = subsidiaryCompanies ? subsidiaryCompanies?.length === 0 : true;
    setIsShow(!isNoShowTmp);
    setIsSubsidiary(isSubsidiaryTmp);
    getIsOnSubsidiary?.(isNoShowTmp || isSubsidiaryTmp);

    const optionsTmp: any = [
      {
        groupKey: GROUPS.PARENT,
        value: parentCompany?.company_id || '',
        text: (
          <div className="dbi-company-option">
            <div className="dbi-company-option-icon">
              <Image style={{ width: 22, height: 22 }} entityType="company" src={parentCompany?.img_url} />
            </div>
            <div className="dbi-company-option-name">
              <EllipsisHover text={parentCompany?.name} />
            </div>
          </div>
        ),
        searchWord: parentCompany?.name,
      },
    ];
    subsidiaryCompanies?.forEach((t: { [keyName: string]: string }) => {
      optionsTmp.push({
        groupKey: GROUPS.SUBSIDIARY,
        value: t?.company_id || '',
        text: (
          <div className="dbi-company-option">
            <div className="dbi-company-option-icon">
              <Image style={{ width: 22, height: 22 }} entityType="company" src={t?.img_url} />
            </div>
            <div className="dbi-company-option-name">
              <EllipsisHover text={t?.name} />
            </div>
          </div>
        ),
        searchWord: t?.name || '',
      });
    });
    setOptions(optionsTmp);
  }

  const onSearch = (keyword?: string) => {
    // setSearchWord(keyword);
    const source = JSON.parse(JSON.stringify(options));
    if (keyword) {
      const list = source?.filter((v: any) =>
        v?.searchWord?.toLocaleLowerCase()?.includes(keyword?.toLocaleLowerCase()),
      );
      if (list?.length) {
        setIsEmpty(false);
      } else {
        setIsEmpty(true);
      }
    } else {
      setIsEmpty(false);
    }
  };

  const searchFilter = (inputValue: string, option: any): boolean => {
    // setRenderSearchWord(inputValue || '');
    if (option?.searchWord?.toLocaleLowerCase()?.includes(inputValue?.toLocaleLowerCase())) {
      return true;
    }
    return false;
  };

  useEffect(() => {
    getCompanyList(value);
  }, [value]);

  useEffect(() => {
    // 搜索为空时修改DOM文案
    if (isEmpty) {
      const D = document.querySelector(
        '.tea-overlay .dbi-parent-subsidiary-company-select-box.search-list-empty .tea-action-state__text',
      );
      if (D) D.innerHTML = formatMessage({ id: `dbi_no_results_found` });
    }
  }, [isEmpty]);

  if (!isShow) return null;

  return (
    <Select
      className={classNames(className, {
        'dbi-parent-subsidiary-company-select': true,
        'disabled-hover': isDisabledOpen,
        'parent-company-img': !isSubsidiary,
        'child-company-img': isSubsidiary,
      })}
      overlayClassName={classNames({
        'dbi-parent-subsidiary-company-select-overlay': true,
        'search-list-empty': isEmpty,
      })}
      searchable
      // searchPlaceholder={formatMessage({ id: 'dbi_search' })}
      size="m"
      appearance="button"
      button={formatMessage({ id: 'dbi_company_subsidiary' })}
      value={value}
      groups={groups}
      onChange={onChange}
      onSearch={onSearch}
      // onSearch={(keyword) => setSearchWord(keyword as string)}
      // filterRender={(inputValue, option) => {
      //   setRenderSearchWord(inputValue || '');

      //   return option.text;
      // }}
      // filter={(inputValue, option) => {
      //       setRenderSearchWord(inputValue || '');
      //       if(option?.searchWord?.toLocaleLowerCase()?.includes(inputValue?.toLocaleLowerCase())){
      //         return true;
      //       }
      //   return false;
      // }}
      filter={searchFilter}
      // 组件受控打开/关闭
      open={open}
      // 外部指定禁止打开时禁止打开
      onOpenChange={(open) => !isDisabledOpen && setOpen(open)}
      onClose={() => {
        // setSearchWord('');
        // setRenderSearchWord('');
      }}
      options={options}
      listWidth={230}
      // 超出277出现滚动条
      listHeight={277}
      placement="bottom-start"
      placementOffset={10}
      placeholder=""
      virtual
    // matchButtonWidth
    />
  );
}

export default index;
